import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {IncomingCreateType} from "../../pages/inventory/incoming/create/interface";
import {InvSearchParamType} from "../../pages/inventory/inv/list/interface";
import {IncomingUpdateType} from "../../pages/inventory/inv/history/interface";

const url = "api/inventory/incoming/";

export async function createIncomingCode(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_incoming_code");
    } catch (err: any) {
        return err?.response;
    }
}

export async function createIncoming(data: IncomingCreateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_incoming", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateIncoming(data: IncomingUpdateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_incoming", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadIncomingExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_incoming_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadIncomingBarcode(data: { barcode: string }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_incoming_barcode", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readInventoryAtIncoming(param: InvSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory_at_incoming", param);
    } catch (err: any) {
        return err?.response;
    }
}